import { Card, CardBody } from "@heroui/react";
import { motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";

const avatarImages = [
  "/avatar/alex.png",
  "/avatar/sofia.png",
  "/avatar/artistic.jpg",
  "/avatar/jamal.png",
  "/avatar/emily-chen.png",
  "/avatar/carlos-rivera.png",
];

const TestimonialSection: React.FC = () => {
  const { t } = useTranslation();

  // Mix of meme avatars and normal profile pics - like real student testimonials
  const testimonials = [
    {
      id: 1,
      content: t("modern.testimonials.items.student1.content"),
      name: t("modern.testimonials.items.student1.name"),
      role: t("modern.testimonials.items.student1.role"),
      avatar: avatarImages[0],
    },
    {
      id: 2,
      content: t("modern.testimonials.items.student2.content"),
      name: t("modern.testimonials.items.student2.name"),
      role: t("modern.testimonials.items.student2.role"),
      avatar: avatarImages[1],
    },
    {
      id: 3,
      content: t("modern.testimonials.items.student3.content"),
      name: t("modern.testimonials.items.student3.name"),
      role: t("modern.testimonials.items.student3.role"),
      avatar: avatarImages[2],
    },
    {
      id: 4,
      content: t("modern.testimonials.items.student4.content"),
      name: t("modern.testimonials.items.student4.name"),
      role: t("modern.testimonials.items.student4.role"),
      avatar: avatarImages[3],
    },
    {
      id: 5,
      content: t("modern.testimonials.items.student5.content"),
      name: t("modern.testimonials.items.student5.name"),
      role: t("modern.testimonials.items.student5.role"),
      avatar: avatarImages[4],
    },
    {
      id: 6,
      content: t("modern.testimonials.items.student6.content"),
      name: t("modern.testimonials.items.student6.name"),
      role: t("modern.testimonials.items.student6.role"),
      avatar: avatarImages[5],
    },
  ];

  return (
    <section className="pt-4 md:pt-8 pb-8 md:pb-12 overflow-hidden bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        <motion.div
          className="mb-8 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            {t("modern.testimonials.title")}
          </h2>
        </motion.div>

        {/* Static Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <Card shadow="sm" className="h-full">
                <CardBody className="p-6">
                  <p className="text-gray-700 mb-6">{testimonial.content}</p>
                  <div className="flex items-center">
                    {/* Meme/anime avatar - like students actually use */}
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                    />
                    <div className="ml-3">
                      <p className="font-medium text-gray-900 text-sm leading-tight">
                        {testimonial.name}
                      </p>
                      <p className="text-xs text-gray-500 leading-tight mt-0.5">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
